module.exports = "https://static.wmbcdn.com/uniweb/images/0cf8d9f7293b6c71a1138e1af44297d3.svg";